import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router";
import { useAuthStore, useMenuStore } from "../../core/stores";
import { hasMenuAccess } from "../../core/helpers";
export const ProtectedRoute = ({ menuId, children, fallback, loadingComponent, }) => {
    const accessToken = useAuthStore((state) => state.accessToken);
    const authStage = useAuthStore((state) => state.authStage);
    const menus = useMenuStore((state) => state.menus);
    // 1. FAIL-CLOSED: No session
    if (!accessToken) {
        // Jika sedang dalam tahap MFA, lempar ke halaman MFA
        if (authStage === "MFA_PENDING") {
            return _jsx(Navigate, { to: "/auth/mfa", replace: true });
        }
        return _jsx(Navigate, { to: "/auth/login", replace: true });
    }
    // 2. Authorization: Check Permissions
    if (!menus) {
        return loadingComponent || fallback || _jsx("div", { children: "Loading..." });
    }
    if (!hasMenuAccess(menus, menuId)) {
        return fallback || _jsx(Navigate, { to: "/unauthorized", replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
